// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectPart_wrapper__KZYNS","title":"ProjectPart_title__35KuX","each-slide-effect":"ProjectPart_each-slide-effect__nUGcM","slide-btn":"ProjectPart_slide-btn__wRBzJ"};